import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Header from "../Components/Header";
import SidePanel from "../Components/SidePanel";
import { toast } from "react-toastify";
import axios from "axios";

const ViewCustomer = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [isCollapsed, setCollapsed] = useState(false);
  const [customer, setCustomer] = useState(null);

  useEffect(() => {
    fetchCustomer();
  }, []);

  const fetchCustomer = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/superadmin/get_customer/${id}/`
      );
      if (response.status === 200) {
        setCustomer(response.data);
      } else {
        toast.error("Failed to fetch customer data");
      }
    } catch (error) {
      console.error("Error fetching customer:", error);
      toast.error("Error fetching customer");
    }
  };

  return (
    <div>
      <Header toggleSidePanel={() => setCollapsed((prev) => !prev)} />
      <div className="flex">
        <SidePanel isCollapsed={isCollapsed} />

        <main className="bg-[#282828] w-full min-h-screen overflow-hidden">
          <section className="pt-8 pb-6 px-6">
            <h2 className="text-white text-2xl font-semibold mb-2">
              Customer Details
            </h2>
          </section>

          <section className="px-6 pb-12">
            <div className="bg-[#1f1f1f] border border-[#333] rounded-xl shadow-md p-8 text-white">
              {customer ? (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                  <div>
                    <label className="text-sm text-gray-400">Farm Name</label>
                    <p className="text-md text-gray-200 font-medium">
                      {customer.farm_name}
                    </p>
                  </div>
                  <div>
                    <label className="text-sm text-gray-400">Email</label>
                    <p className="text-md text-gray-200 font-medium">
                      {customer.email}
                    </p>
                  </div>
                  <div>
                    <label className="text-sm text-gray-400">Mobile</label>
                    <p className="text-md text-gray-200 font-medium">
                      {customer.mobile}
                    </p>
                  </div>
                  <div>
                    <label className="text-sm text-gray-400">License Key</label>
                    <p className="text-md text-gray-200 font-medium">
                      {customer.license_key}
                    </p>
                  </div>
                  <div>
                    <label className="text-sm text-gray-400">Status</label>
                    <p>
                      <span
                        className={`inline-block mt-1 px-3 py-1 text-sm font-semibold rounded-full ${
                          customer.is_active
                            ? "bg-green-600 text-white"
                            : "bg-red-600 text-white"
                        }`}
                      >
                        {customer.is_active ? "Active" : "Inactive"}
                      </span>
                    </p>
                  </div>
                  <div>
                    <label className="text-sm text-gray-400">Validity Months</label>
                    <p className="text-md text-gray-200 font-medium">
                      {customer.validity_months}
                    </p>
                  </div>
                </div>
              ) : (
                <p className="text-gray-400">Loading customer details...</p>
              )}

              <div className="mt-10">
                <button
                  onClick={() => navigate(-1)}
                  className="bg-gray-700 hover:bg-gray-600 text-white px-6 py-2 rounded-md transition duration-200"
                >
                Back
                </button>
              </div>
            </div>
          </section>
        </main>
      </div>
    </div>
  );
};

export default ViewCustomer;
